import { IChartEventBadgeProps } from '../../../utils/chart-events-utils'
import { getChartEventEarningSvgString } from './earnings'

export function getChartEventEarningsNeutralSvgString(args: IChartEventBadgeProps) {
  return getChartEventEarningSvgString({ ...args, isFuture: false })
}
